import { Text, type TextProps } from '@mantine/core';
import type { SentencePart } from '../../domain/sentence.js';

/**
 * The one renderer for `SentencePart[]`: prose with monospace identifiers, never re-cased.
 * `noWrapMono` keeps each identifier on one line (the push review's environment names).
 */
export const SentenceText = ({
    parts,
    noWrapMono = false,
    ...text
}: { parts: readonly SentencePart[]; noWrapMono?: boolean } & TextProps) => (
    <Text {...text}>
        {parts.map((part, index) => (
            <span key={index}>
                {part.before}
                {part.mono && (
                    <span className="rgs-numeric" style={noWrapMono ? { whiteSpace: 'nowrap' } : undefined}>
                        {part.mono}
                    </span>
                )}
                {part.after}
            </span>
        ))}
    </Text>
);
